import { Helmet } from "react-helmet-async";

const SITE_URL = "https://victoryaluminium.net";
const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1621831337128-35676ca30868?auto=format&fit=crop&w=1200&q=80";

/**
 * Page-level SEO. Sets title, meta description, canonical, OG, twitter, plus optional JSON-LD.
 */
export default function SEO({ title, description, path = "/", image, jsonLd }) {
  const fullTitle = title
    ? `${title} | Victory Aluminium & Hardwares`
    : "Victory Aluminium & Hardwares | Premium Aluminium Dealer · Chennai · Since 1998";
  const desc = description || "Chennai's trusted aluminium dealer since 1998. Premium aluminium sections, City BOND ACP, HPL panels, doors, windows, partitions, ladders. Authorised City BOND distributor. Pan-India supply.";
  const url = `${SITE_URL}${path === "/" ? "" : path}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
